<template>
    <div class="quiz__nav quiz__nav_results" style="position: relative;">
        <button class="quiz__nav-btn" @click="addAllToBag">ADD ALL TO BAG</button>
        <a @click="goToBeginning" class="quiz__restart-btn">START OVER</a>
    </div>
</template>

<script>
import { bus } from '../utilities'
import { analytics, shopping } from 'shiseido-apis'

export default {
    props: {
        wishlist: { type: Array, required: true },
    },
    methods: {
        addAllToBag() {
            shopping.addToCart(this.wishlist)
        },
        goToBeginning() {
            analytics.registerClick({
                element: 'Start Over',
                toolname: 'Gift Guide',
                question: 'Results',
                answers: [],
            })

            bus.$emit('next', { path: '/' })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/results-ctas.vue